import styled from 'styled-components'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'

import SearchButton from 'components/form/SearchButton'
import CourseBasicData from 'components/form/course/CourseBasicData'
import CourseGpsVersions from 'components/form/course/CourseGpsVersions'
import CourseGpsLocations from 'components/form/course/CourseGpsLocations'
import { ClientRoute } from 'routes/client'

interface Props {
  course: Course
  clubId: number | null
  toggleClubModal: () => void
}

export default function CourseGps({ course, clubId, toggleClubModal }: Props): JSX.Element {
  const intl = useIntl()

  return (
    <PageContainer>
      <SectionContainer>
        <CourseBasicData course={course} clubId={clubId} />
      </SectionContainer>

      <SectionContainer>
        <CourseGpsVersions course={course} />
      </SectionContainer>
      <SectionContainer>
        <CourseGpsLocations course={course} />
      </SectionContainer>
      <SectionContainer>
        <CourseActionButtons>
          <CreateCourseVersion
            onClick={() => null}
            text={intl.formatMessage({ id: 'strings.createCourseVersion' })}
            status="idle"
            disabled
          />
          <ActionButton onClick={toggleClubModal}>{intl.formatMessage({ id: 'strings.editClub' })}</ActionButton>
          {course.club?.id && (
            <LinkButton to={ClientRoute.ADMIN_CLUB_COURSES(course.club.id)}>
              {intl.formatMessage({ id: 'strings.backToCourses' })}
            </LinkButton>
          )}
        </CourseActionButtons>
      </SectionContainer>
    </PageContainer>
  )
}

const PageContainer = styled.div`
  margin: 0 10px;
  padding: 0 0 20px 0;
  min-height: 500px;

  & a {
    color: ${(props) => props.theme.palette.primary.main};
    text-decoration: none;
  }
`

const SectionContainer = styled.div`
  background-color: ${(props) => props.theme.customPalette.light};
  margin: 0 0 10px;
  padding: 20px;
`

const CourseActionButtons = styled.div`
  display: flex;
  & > * {
    margin-right: 30px;
  }
`

const CreateCourseVersion = styled(SearchButton)``

const LinkButton = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 180px;
  height: 50px;
  color: ${(props) => props.theme.palette.primary.main};
  border: 2px solid;
  border-color: ${(props) => props.theme.palette.primary.main};
  border-radius: 5px;
  font-weight: 500;
  font-size: 0.9em;
  text-decoration: none;

  &:hover {
    opacity: 0.85;
  }
`

const ActionButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 180px;
  height: 54px;
  background-color: transparent;
  color: ${(props) => props.theme.palette.primary.main};
  border: 2px solid;
  border-color: ${(props) => props.theme.palette.primary.main};
  border-radius: 5px;
  font-weight: 500;
  font-size: 0.9em;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    opacity: 0.85;
  }
`
